import { InjectionToken } from "@angular/core";
import { Product } from "@shared/models";

export const MARKET_LISTENER = new InjectionToken<IMarketListener>('cwt-market-listener');

export interface IMarketListener {
    onPurchaseComplete?(product: Product): Promise<void>;
    onPurchaseFailed?(product: Product): Promise<void>;
    onPurchaseRefreshed?(): Promise<void>;
}